import React from 'react';
import cx from 'classnames';

import { Col, Image, Row } from 'react-bootstrap';
import styles from '../../FliteviewSettingsView.module.scss';

import _ from 'lodash';
import TinymceEditor from './editor';
import { localizedStrings } from '../../../../../../localization';
import { InputWithIcon } from 'src/components/input';
class TextCustomization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPlaceholder: _.get(this.props, "showPlaceholder", true)
    }

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedViewerSettings = this.localizedSettings.account.viewer_settings;
  }

  _handleButtonTextChange(e) {
    this.setState({
      buttonText: e.target.value,
    });

    this.props.onTextChange({
      'buttonText': e.target.value
    });
  }

  _handlePlaceholderTextChange(e) {
    this.setState({
      placeholderText: e.target.value,
    });

    this.props.onTextChange({
      'placeHolder': e.target.value
    });
  }

  render() {
    return (
      <Row className={cx(styles.textEditor, styles.column)}>
        <div className={styles.title}>{this.props.title}</div>
        <div className={styles.description}>{this.props.description}</div>
        <div className={styles.header}>
          {this.localizedViewerSettings.library_settings.header}
        </div>

        <Col xl={12} lg={12} md={12}>
          <Row>
            <Col xl={8} lg={8} className={styles.textEditorColumn}>
              <TinymceEditor
                account={this.props.account}
                content={_.get(this.props.text, `heading`)}
                onChange={(content) =>
                  this.props.onTextChange({ heading: content })
                }
                height={160}
              />
              <div className={styles.header}>
                {this.localizedViewerSettings.library_settings.description}
              </div>
              <TinymceEditor
                account={this.props.account}
                content={_.get(this.props.text, `descriptionText`)}
                onChange={(content) =>
                  this.props.onTextChange({ descriptionText: content })
                }
                height={160}
              />
              <Row>
                <Col lg={6} xl={6} md={6}>
                  <div className={styles.header}>
                    {this.localizedViewerSettings.library_settings.button}
                  </div>

                  <InputWithIcon
                    value={_.get(this.props.text, `buttonText`)}
                    onChange={this._handleButtonTextChange.bind(this)}
                    maxLength={20}
                  />
                </Col>
                {this.state.showPlaceholder && (
                  <Col lg={6} xl={6} md={6}>
                    <div className={styles.header}>
                      {
                        this.localizedViewerSettings.library_settings
                          .placeholder
                      }
                    </div>

                    <InputWithIcon
                      value={_.get(this.props.text, `placeHolder`)}
                      onChange={this._handlePlaceholderTextChange.bind(this)}
                      maxLength={20}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col lg={4} xl={4} md={4} className={styles.image}>
              <Image
                src={this.props.previewImage}
                width="245px"
                height="172px"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default TextCustomization;